import { LogEventRequestModel } from '@/models/DTO/event-log/log-event.model';
import { Inject, injectable } from 'inversify-props';
import { BaseAPIService } from './base-api.service';

const API_VERSION: string = process.env.VUE_APP_API_VERSION;
const EVENT_LOG_STUB_URL = `/api/v${API_VERSION}/EventLog`;
const LOG_EVENT_URL = `${EVENT_LOG_STUB_URL}/LogEvent`;

export interface EventLogService {
  logEvent(logEventModel: LogEventRequestModel): Promise<void>;
}

@injectable()
export class EventLogService implements EventLogService {
  @Inject()
  private readonly _baseAPIService!: BaseAPIService;

  public async logEvent(logEventModel: LogEventRequestModel): Promise<void> {
    await this._baseAPIService.client.post(LOG_EVENT_URL, {
      ...logEventModel
    });
  }
}
